import { Box, Typography } from "@jewlr/storybook/core"
import loadable from "@loadable/component"
import PropTypes from "prop-types"
import React from "react"
import { Helmet } from "react-helmet-async"

import LandingFeatureImageBox from "areas/landing/elements/landing-feature-image-box"
import { retry } from "helpers/application"

import { banner as getBanner, whatTheyGet as getWhatTheyGet } from "./data"
import ExplainedModal from "./explained-modal"
import HowItWorks from "./how-it-works"

const LandingHeroBanner = loadable(() =>
  retry(() => import("areas/landing/elements/hero-banner"))
)

const InstantGiftExplained = ({ action, inCart, inModal }) => {
  const banner = getBanner()

  return (
    <Box containWide mb={{ _: 2, tablet: 5 }}>
      {inModal ? (
        <ExplainedModal action={action} inCart={inCart} inModal={inModal} />
      ) : (
        <>
          <Helmet>
            {banner.data.items[0].image.srcSet.map((srcset) => (
              <link
                as="image"
                /* eslint-disable react/no-unknown-property */
                fetchPriority="high"
                imageSizes={srcset.sizes}
                imageSrcSet={srcset.srcSet}
                key={srcset.media}
                media={srcset.media}
                rel="preload"
              />
            ))}
          </Helmet>
          <LandingHeroBanner element={banner} lazyload={false} />
          <Box px={{ _: 2, desktop: "60px" }}>
            <Typography
              mb={{ _: 3, tablet: 6 }}
              mt={{ _: 4, tablet: "60px" }}
              textAlign="left"
              variant="h2"
            >
              How it Works
            </Typography>
            <HowItWorks />
            <LandingFeatureImageBox element={getWhatTheyGet()} />
          </Box>
        </>
      )}
    </Box>
  )
}

InstantGiftExplained.propTypes = {
  action: PropTypes.func,
  inCart: PropTypes.bool,
  inModal: PropTypes.bool,
}

export default InstantGiftExplained
